<template>
    <div>
        <div class="upload-img">
            <el-upload
                class="avatar-uploader"
                action="string"
                :show-file-list="false"
                :http-request="uploadImage"
                :on-success="handleAvatarSuccess"
                :on-change="fileChange"
                :before-upload="beforeAvatarUpload">
                <div v-if="!imageUrl">
                  <i class="el-icon-plus avatar-uploader-icon"></i>
                  <span class="reminder">点击上传</span>
                </div>
                <div v-else>
                  <img fit="cover" class="avatar" :src="imageUrl" alt="">
                  <div class="img-icon">
                    <i class="el-icon-zoom-in" @click.stop="preview"></i>
                    <!-- <i class="el-icon-plus"></i> -->
                    <i class="el-icon-delete" @click.stop="remove"></i>
                  </div>
                </div>    
            </el-upload>
        </div>
        <div v-if="dialogVisible" class="modal" @click.stop="dialogVisible = false;">
            <img :src="imageUrl" alt="" class="big-img">
        </div>
    </div>
</template>
<script>
import { uploadGetUrl } from '@/api/subManage'
export default {
    name: 'UploadImg',
    data() {
        return {    
            imageUrl: '',
            dialogImageUrl: '',
            dialogVisible: false
        };
    },
    props: {
        echoImgUrl: {
            type: String
        }
    },
    methods: {
        handleAvatarSuccess(res, file) {
            this.imageUrl = URL.createObjectURL(file.raw);
            this.dialogImageUrl = this.imageUrl;
        },
        beforeAvatarUpload(file) {
            const isLt10M = ((file.size / 1024 / 1024) <= 10);
            const isJPG = file.type === 'image/jpeg' || 'image/png' || 'image/jpg' || 'image/gif'; 
            if (!isJPG) {
                this.$message.error('上传图片大小不能超过 10MB!');
            }
            if (!isLt10M) {
                this.$message.error('上传图片大小不能超过 10MB!');
            }
            return isJPG && isLt10M;
        },  
        uploadImage(param) {
            const formData = new FormData()
            formData.append('file', param.file)
            uploadGetUrl(formData).then(res => {
                if (res.code === 200) {
                    param.onSuccess();
                    this.$emit('getImgUrl', res.data.fileUrl);
                }  
            }).catch(err => {})
        },
        fileChange() {},
        imageEcho() {
            if(this.echoImgUrl) {
                this.imageUrl = this.echoImgUrl
                this.dialogImageUrl = this.imageUrl;
            }
        },
        preview() {
          this.dialogVisible = true
        },
        remove() {
            this.$confirm('是否确认删除图片?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.imageUrl = '';
                this.dialogImageUrl = '';
                this.$emit('getImgUrl', '');
            })
        }
        
    },
    mounted() {
        this.imageEcho();
    },
    watch: {
        echoImgUrl: 'imageEcho'
    }
}
</script>

<style lang="scss" scoped>
    .upload-img {
        width: 122px;
    }
    .reminder {
        color: #8A96A1;
        font-size: 12px;
        position: relative;
        top: 16px;
    }
    .avatar {
        width: 120px;
        height: 120px;
        display: block;
        background-color: #F3F6F9;
    }
    .upload-img:hover .img-icon {
        display: flex;
        display: -webkit-flex;
        justify-content: space-around;
        align-items: center;
    }
    .modal {
      position: fixed;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.5);
      z-index: 990;
      display: flex;
      justify-content: center;
      align-items: center;
      .big-img {
        // min-width: 50%;
        max-width: 800px;
        max-height: 500px;
      }
    }
    .img-icon{
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.5);
      font-size: 24px;
      position: absolute;
      color: white;
      top: 0;
      left: 0;
      display: none;
    }
</style>
